module.exports = __webpack_public_path__ + "static/media/smallstar.26c37bac.svg";